class Logger {
    constructor() {
        this._enabled = false;
    }
    enable() {
        this._enabled = true;
    }
    log(...messages) {
        if (this._enabled) {
            console.log(...messages);
        }
    }
    error(...messages) {
        if (this._enabled) {
            console.error('[ERROR]', ...messages);
        }
    }
    warning(...messages) {
        if (this._enabled) {
            console.warn('[WARN]', ...messages);
        }
    }
    debug(...messages) {
        if (this._enabled) {
            console.debug('[DEBUG]', ...messages);
        }
    }
}
const logger = new Logger;
export { logger as Logger };
//# sourceMappingURL=Logger.js.map